import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { map, Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PageEditScreenValidationService } from '../page-edit-screen/services/page-edit-screen.validation.service';

@Component({
  selector: 'osn-cxb-tray-alert-message',
  templateUrl: './tray-alert-message.component.html',
  styleUrls: ['./tray-alert-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrayAlertMessageComponent implements OnDestroy {
  private readonly destroyed$ = new Subject<void>();

  constructor(private readonly pageEditScreenValidationService: PageEditScreenValidationService) {}

  public validationErrors$ = combineLatest([
    this.pageEditScreenValidationService.isOnDemandPageValidForPublishing$,
    this.pageEditScreenValidationService.isOSNPlusPageValidForPublishing$,
    this.pageEditScreenValidationService.isMarketingEmailBlockingPageUnique$,
    this.pageEditScreenValidationService.isMarketingEmailBlockingPageItemValidForPublishing$,
    this.pageEditScreenValidationService.isRecommendationEditorialPageUseCaseExists$,
  ]).pipe(
    map(
      ([
        isOnDemandPageValidForPublishing,
        isOSNPlusPageValidForPublishing,
        isMarketingEmailBlockingPageUnique,
        isMarketingEmailBlockingPageItemValidForPublishing,
        isRecommendationEditorialPageUseCaseExists,
      ]) => {
        return [
          { hasError: !isOnDemandPageValidForPublishing, errorMessage: 'A spotlight tray is required to publish this page!' },
          { hasError: !isOSNPlusPageValidForPublishing, errorMessage: 'A Hero tray is required to publish this page!' },
          {
            hasError: !isMarketingEmailBlockingPageUnique,
            errorMessage: 'MarketingEmailBlockerPageItem must only be visible on a live page once',
          },
          {
            hasError: !isMarketingEmailBlockingPageItemValidForPublishing,
            errorMessage:
              'MarketingEmailBlocker tray must be after a content (portrait, top10, collection, season) tray on every live page combination',
          },
          { hasError: !isRecommendationEditorialPageUseCaseExists, errorMessage: 'Editorial Use-case is no longer available' },
        ];
      }
    ),
    takeUntil(this.destroyed$)
  );

  public ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
